/**
 * Product Proxy — Client
 * Talks to the Cloudflare Worker for product search and extraction.
 * 
 * Worker URL: update REACT_APP_PRODUCT_PROXY_URL in .env when deployed.
 * Dev fallback: http://localhost:8787
 */

const PROXY_URL = process.env.REACT_APP_PRODUCT_PROXY_URL || 'https://product-proxy.brian-nulf79.workers.dev';

/**
 * Search for products on a specific store or both.
 * @param {string} query - Search terms
 * @param {string|null} store - 'amazon', 'walmart', or null for both
 * @returns {Promise<{results: Array}|{amazon: Array, walmart: Array}>}
 */
export async function searchProducts(query, store = null) {
  const endpoint = store 
    ? `${PROXY_URL}/search`
    : `${PROXY_URL}/search-all`;
  
  const body = store ? { query, store } : { query };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `Search failed (${response.status})`);
  }

  return response.json();
}

/**
 * Extract product data from an Amazon or Walmart URL.
 * @param {string} url - Full product page URL
 * @returns {Promise<{name, price, image, url, store, asin?}>}
 */
export async function extractProductUrl(url) {
  const response = await fetch(`${PROXY_URL}/extract`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url })
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `Extraction failed (${response.status})`);
  }

  return response.json();
}

export { PROXY_URL };
